module.exports = __webpack_public_path__ + "img/pager2img2.c3ded93a.png";